import {
  FieldProps,
  FormFieldTypes,
  SelectionTypes,
} from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";
import {
  ISubmissionFormDataServer,
  IFormSubmission,
  IFieldSubmissionMap,
  ISubmissionFormFieldDataServer,
  IFormFieldSubmission,
  IDuplicateCheckFormData,
  IDuplicateCheckFieldData,
  ITableSubmissionMap,
  ITableSubmissionMapServer,
  IWorkflowNotification,
  IWorkflowServer,
  Events,
  IDatagridValue,
  IDataGridActionsMapper,
} from "@common/redux/formSubmission/interface";
import {
  IFormLevelRuleActionServer,
  IFormLevelRuleClient,
  IFormServer,
} from "../forms/interface";
import { transformFormDataServerToClient } from "../forms/utils";
import { IFieldsMap } from "../formBuilder/interface";
import { formatUpdatedDate } from "@utils/DateHelper";
import { checkFieldRuleConditions } from "@presentation/FormBuilder/components/utils";
import { IMultiChoiceFieldOptionsClient } from "@erelego/design-system/interface/Forms/FormFieldsInterface/FormMultipleChoicesField/interface";

function isValidId(id) {
  const test = /^[a-zA-Z0-9]{24}$/.test(id);
  return test;
}
const extractSubmissionIds = (optionKey: string) => {
  const result = [];
  if (typeof optionKey != "string") return;
  const parts = optionKey.split("__");
  result.push(parts[0]);
  if (isValidId(result[0])) {
    return result;
  }
};

export const transFormSubmissionDataClientToServer = (
  submissionFormDataClient: IFormSubmission,
  formId: string,
  fieldsToHide: string[],
  pageToHide: string[],
  fieldsMap: IFieldsMap,
  openedDate?: number,
  datagridMapper?: any,
  submissionMap?: IFormSubmission
): ISubmissionFormDataServer => {
  const submissionFormFieldsDataServer: ISubmissionFormFieldDataServer = {};
  const submissionId: string = submissionFormDataClient?.submissionId;
  const submissionFormFieldsDataClient: IFieldSubmissionMap =
    submissionFormDataClient?.fieldSubmissionMap;
  let relatedSubmissionIds = [];
  for (const fieldId in submissionFormFieldsDataClient) {
    if (
      fieldsToHide.includes(fieldId) &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.LOOKUP &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.CALCULATIVE &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.NUMBER_INPUT &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.TEXT_INPUT &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.TEXT_AREA &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.DESCRIPTION &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.DATE_INPUT &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.DATE_TIME_PICKER &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.TIME_PICKER &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.CURRENCY &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.DROPDOWN &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.MULTIPLE_CHOICES &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.DECISION_BOX &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.RATING &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.LINEAR_SCALING &&
      submissionFormFieldsDataClient[fieldId].fieldType !=
      FormFieldTypes.YEAR_SELECTOR
    )
      continue;
    const fieldData: FieldProps = fieldsMap[fieldId];
    if (pageToHide.includes(fieldData?.parentFormId)) continue;
    const { fieldType, fieldSubmissionValue } =
      submissionFormFieldsDataClient[fieldId];
    fieldSubmissionValue;
    const updatedFieldType = fieldType ?? fieldData?.fieldType;
    switch (updatedFieldType) {
      case FormFieldTypes?.DROPDOWN:
        if (fieldSubmissionValue?.selectedOption) {
          //selectedOption for single select
          submissionFormFieldsDataServer[fieldId] =
            fieldSubmissionValue?.selectedOption;
        } else if (fieldSubmissionValue?.value?.["optionValue"]) {
          submissionFormFieldsDataServer[fieldId] = fieldSubmissionValue?.value;
        }
        if (fieldSubmissionValue?.selectedOptions) {
          //selectedOptions for multi select
          submissionFormFieldsDataServer[fieldId] =
            fieldSubmissionValue?.selectedOptions;
        }
        break;
      case FormFieldTypes?.YEAR_SELECTOR:
        if (fieldSubmissionValue?.selectedOptions) {
          //selectedOptions for multi select
          submissionFormFieldsDataServer[fieldId] =
            fieldSubmissionValue?.selectedOptions;
        } else {
          submissionFormFieldsDataServer[fieldId] = [];
        }
        break;
      case FormFieldTypes?.MULTIPLE_CHOICES:
        if (fieldSubmissionValue?.selectedOption) {
          //selectedOption for single select
          submissionFormFieldsDataServer[fieldId] =
            fieldSubmissionValue?.selectedOption;
        }
        if (fieldSubmissionValue?.selectedOptions) {
          //selectedOptions for multi select
          submissionFormFieldsDataServer[fieldId] =
            fieldSubmissionValue?.selectedOptions;
        }
        break;
      case FormFieldTypes?.LINEAR_SCALING:
        const value = Number(fieldSubmissionValue?.selectedOption ?? 0);
        submissionFormFieldsDataServer[fieldId] = isNaN(value) ? 0 : value;
        break;
      case FormFieldTypes?.FILE_UPLOAD:
        submissionFormFieldsDataServer[fieldId] =
          fieldSubmissionValue?.uploadedFiles;

        break;
      case FormFieldTypes?.RATING:
        submissionFormFieldsDataServer[fieldId] =
          fieldSubmissionValue?.selectedOption;
        break;
      case FormFieldTypes?.CHECK_BOX:
        submissionFormFieldsDataServer[fieldId] =
          fieldSubmissionValue?.checkBoxValue;
        break;
      case FormFieldTypes?.BUTTON:
        submissionFormFieldsDataServer[fieldId] =
          fieldSubmissionValue?.buttonValue;
        break;
      case FormFieldTypes?.BANNER:
        submissionFormFieldsDataServer[fieldId] =
          fieldSubmissionValue?.bannerValue;
        break;
      case FormFieldTypes?.SIGNATURE_BOX:
        submissionFormFieldsDataServer[fieldId] =
          fieldSubmissionValue?.manualSignatureData;
        break;
      case FormFieldTypes?.DOUBLE_PANEL:
        submissionFormFieldsDataServer[fieldId] =
          fieldSubmissionValue?.panelSelectedItemList;
        break;
      case FormFieldTypes?.PAYMENT:
        const paymentValue = fieldSubmissionValue?.paymentValue;
        submissionFormFieldsDataServer[fieldId] = {
          txnAmount: paymentValue?.amount ? Number(paymentValue?.amount) : 0,
          orderId: paymentValue?.orderId,
          updatedDate: paymentValue?.updatedDate,
          status: paymentValue?.status,
          paymentGateway: paymentValue?.paymentGateway,
        };
        // fieldSubmissionValue?.paymentValue?.amount;
        break;
      case FormFieldTypes?.LOOKUP:
        if (fieldSubmissionValue?.selectedOption) {
          const displayType = fieldData?.fieldValue?.displayType;
          //selectedOption for single select
          const id = fieldSubmissionValue?.selectedOption["optionKey"];
          const data = id && extractSubmissionIds(id);
          relatedSubmissionIds = data?.length
            ? [...relatedSubmissionIds, ...data]
            : [...relatedSubmissionIds];
          submissionFormFieldsDataServer[fieldId] =
            displayType == "TEXT"
              ? fieldSubmissionValue?.selectedOption?.optionValue
              : fieldSubmissionValue?.selectedOption;
        } else if (fieldSubmissionValue?.selectedOptions?.length) {
          const id = fieldSubmissionValue?.selectedOptions[0]["optionKey"];
          const data = id && extractSubmissionIds(id);
          relatedSubmissionIds = data?.length
            ? [...relatedSubmissionIds, ...data]
            : [...relatedSubmissionIds];
          //selectedOptions for multi select
          submissionFormFieldsDataServer[fieldId] =
            fieldSubmissionValue?.selectedOptions;
        } else {
          if (fieldSubmissionValue?.["optionKey"]) {
            const id = fieldSubmissionValue?.["optionKey"] ?? "";
            const data = id.length && extractSubmissionIds(id);
            relatedSubmissionIds = data?.length
              ? [...relatedSubmissionIds, ...data]
              : [...relatedSubmissionIds];
            submissionFormFieldsDataServer[fieldId] =
              fieldSubmissionValue?.value;
          } else {
            submissionFormFieldsDataServer[fieldId] =
              fieldSubmissionValue?.value;
          }
        }
        break;
      case FormFieldTypes?.GEOLOCATION:
        submissionFormFieldsDataServer[fieldId] =
          fieldSubmissionValue?.geolocationValue; // update based on use
        break;
      case FormFieldTypes?.DATA_GRID:
        submissionFormFieldsDataServer[fieldId] =
          transformDatagridValueServerToClient(
            fieldSubmissionValue?.dataGridValue,
            formId,
            fieldsToHide,
            pageToHide,
            fieldsMap,
            datagridMapper[fieldId],
            datagridMapper,
            submissionMap,
            fieldId,
            submissionId
          ); // update based on use
        break;
      case FormFieldTypes?.CALCULATIVE:
      case FormFieldTypes.NUMBER_INPUT:
      case FormFieldTypes.PIN_CODE:
      case FormFieldTypes?.RATING:
      case FormFieldTypes?.LINEAR_SCALING:
      case FormFieldTypes?.CURRENCY:
        const numberValue = Number(fieldSubmissionValue?.value ?? 0);
        submissionFormFieldsDataServer[fieldId] = isNaN(numberValue)
          ? 0
          : numberValue;
        break;
      case FormFieldTypes?.DATE_INPUT:
        let dateFieldValue;

        if (fieldSubmissionValue?.value === "") {
          dateFieldValue = "";
        } else {
          let date = new Date(fieldSubmissionValue?.value);
          date.setHours(0, 0, 0, 0);
          dateFieldValue = formatUpdatedDate(date);
        }

        submissionFormFieldsDataServer[fieldId] = dateFieldValue;
        break;
      case FormFieldTypes?.TEXT_INPUT:
        const rawValue: any = fieldSubmissionValue?.value ?? "";
         let sanitizedValue = "";
        if (typeof rawValue === "object" && rawValue !== null) {
          sanitizedValue = rawValue && rawValue?.optionValue || "";
        } else if (typeof rawValue === "string") {
          sanitizedValue = rawValue.replace(/\n+/g, "").trim();
        } else {
          sanitizedValue = String(rawValue);
        }
        submissionFormFieldsDataServer[fieldId] = sanitizedValue;
        break;
      case FormFieldTypes.DATE_TIME_PICKER:
        let dateValue = fieldSubmissionValue?.value;
        if (dateValue) {
          const date = new Date(dateValue);
          dateValue = formatUpdatedDate(date);
        }
        submissionFormFieldsDataServer[fieldId] = dateValue;
        break;
      default:
        // const numberField = Number(fieldSubmissionValue?.value ?? 0);
        submissionFormFieldsDataServer[fieldId] = fieldSubmissionValue?.value;
        break;
    }
  }

  const submissionFormDataServer: ISubmissionFormDataServer = {
    formId: formId,
    formData: submissionFormFieldsDataServer,
    relatedSubmissionIds: relatedSubmissionIds,
    openedDate: openedDate,
  };
  return submissionFormDataServer;
};

export const transFormSubmissionDataServerToClient = (
  submissionFormDataServer: ISubmissionFormDataServer,
  formBuilderFormDataServer: IFormServer,
  fieldsToHide: string[]
) => {
  const { fieldsMap } = transformFormDataServerToClient(
    formBuilderFormDataServer
  );
  const { formId, formData, id, createdDate } = submissionFormDataServer;
  const fieldSubmissionIds = Object?.keys(formData);
  const fieldSubmissionMap: IFieldSubmissionMap = {};
  fieldSubmissionIds?.forEach((fieldKey, index) => {
    if (!fieldsMap[fieldKey]) return; // to remove the values that dont exist anymore in form builder
    // if (fieldsToHide.includes(fieldKey)) return;
    const { fieldType, fieldValue } = fieldsMap[fieldKey];
    const fieldSubmissionValueClient: any = formData[fieldKey];
    let fieldSubmissionValue: any; //ISubmissionFieldDataClient define type after merging FB-81
    switch (fieldType) {
      case FormFieldTypes.DROPDOWN:
        const dropdownselectedType = fieldValue?.selectedType;
        if (dropdownselectedType == SelectionTypes?.MULTIPLE_SELECTION) {
          fieldSubmissionValue = {
            selectedOptions: fieldSubmissionValueClient,
          };
        } else {
          fieldSubmissionValue = {
            selectedOption: fieldSubmissionValueClient,
          };
        }
        break;
      case FormFieldTypes.YEAR_SELECTOR:
        fieldSubmissionValue = {
          selectedOptions: fieldSubmissionValueClient,
        };
        break;
      case FormFieldTypes.MULTIPLE_CHOICES:
        const selectedType = fieldValue?.selectedType;
        if (selectedType == SelectionTypes?.MULTIPLE_SELECTION) {
          fieldSubmissionValue = {
            selectedOptions: fieldSubmissionValueClient,
          };
        } else {
          fieldSubmissionValue = {
            selectedOption: fieldSubmissionValueClient,
          };
        }
        break;
      case FormFieldTypes.LINEAR_SCALING:
        fieldSubmissionValue = {
          selectedOption: fieldSubmissionValueClient,
        };
        break;
      case FormFieldTypes.DESCRIPTION:
        fieldSubmissionValue = {
          selectedOption: fieldSubmissionValueClient,
        };
        break;
      case FormFieldTypes.FILE_UPLOAD:
        fieldSubmissionValue = {
          uploadedFiles: fieldSubmissionValueClient,
        };
        break;
      case FormFieldTypes.RATING:
        fieldSubmissionValue = {
          selectedOption: fieldSubmissionValueClient,
        };
        break;
      case FormFieldTypes.CHECK_BOX:
        fieldSubmissionValue = {
          checkBoxValue: fieldSubmissionValueClient,
        };
        break;
      case FormFieldTypes.SIGNATURE_BOX:
        fieldSubmissionValue = {
          manualSignatureData: fieldSubmissionValueClient,
        };
        break;
      case FormFieldTypes.DOUBLE_PANEL:
        fieldSubmissionValue = {
          panelSelectedItemList: fieldSubmissionValueClient,
        };
        break;
      case FormFieldTypes.DATE_INPUT:
        fieldSubmissionValue = {
          value: fieldSubmissionValueClient || "",
        };
        break;
      case FormFieldTypes.DATE_TIME_PICKER:
        let dateValue = "";
        if (fieldSubmissionValueClient) {
          const date = new Date(fieldSubmissionValueClient);
          dateValue = formatUpdatedDate(date);
        }
        fieldSubmissionValue = {
          value: dateValue || "",
        };
        break;
      case FormFieldTypes.PAYMENT:
        fieldSubmissionValue = {
          paymentValue: {
            amount: fieldSubmissionValueClient?.txnAmount || 0,
            orderId: fieldSubmissionValueClient?.orderId || "",
            updatedDate: fieldSubmissionValueClient?.updatedDate || "",
            status: fieldSubmissionValueClient?.status || "",
            paymentGateway: fieldSubmissionValueClient?.paymentGateway || "",
          },
        };
        break;
      case FormFieldTypes.GEOLOCATION:
        fieldSubmissionValue = {
          geolocationValue: {
            latitude: fieldSubmissionValueClient?.latitude + "" || "",
            longitude: fieldSubmissionValueClient?.longitude + "" || "",
            address: fieldSubmissionValueClient?.address || "",
          },
        };
        break;
      case FormFieldTypes.DATA_GRID:
        const submissionVal = transformDatagridValueClientToServer(
          fieldSubmissionValueClient,
          formBuilderFormDataServer
        );
        fieldSubmissionValue = {
          dataGridValue: transformDatagridValueClientToServer(
            fieldSubmissionValueClient,
            formBuilderFormDataServer
          ),
        };
        break;
      case FormFieldTypes.LOOKUP:
        if (
          typeof fieldSubmissionValueClient === "object" &&
          fieldSubmissionValueClient !== null
        ) {
          const lookupSelectionType = fieldValue?.selectionType;
          if (lookupSelectionType == SelectionTypes?.MULTIPLE_SELECTION) {
            fieldSubmissionValue = {
              selectedOptions: fieldSubmissionValueClient,
            };
          } else {
            fieldSubmissionValue = {
              selectedOption: fieldSubmissionValueClient,
            };
          }
        } else {
          fieldSubmissionValue = {
            value: `${fieldSubmissionValueClient}`,
          };
        }
        break;
      case FormFieldTypes.BUTTON:
        fieldSubmissionValue = {
          buttonValue: fieldSubmissionValueClient,
        };
        break;
      default:
        fieldSubmissionValue = {
          value: fieldSubmissionValueClient,
        };
        break;
    }

    const fieldSubmissionDataClient = {
      localId: fieldKey,
      fieldType,
      fieldSubmissionValue,
    } as IFormFieldSubmission;
    fieldSubmissionMap[fieldKey] = fieldSubmissionDataClient;
  });
  const formSubmissionDataClient = {
    localId: formId,
    submissionId: id,
    fieldSubmissionMap: fieldSubmissionMap,
    submittedDate: createdDate,
  } as IFormSubmission;
  return formSubmissionDataClient;
};

export const transFormSubmissionDataToCheckDuplicate = (
  submissionFormDataClient: IFormSubmission,
  formId: string,
  fieldsToHide: string[],
  pageToHide: string[],
  fieldsMap: IFieldsMap,
  submissionId?: string,
  configPageId?: string[],
  formCompositeKeyFields?: [],
  updatedHiddenFields?: []
): IDuplicateCheckFormData => {
  const fieldDetails: IDuplicateCheckFieldData[] = [];
  const compositeFieldDetails: IDuplicateCheckFieldData[] = [];
  const submissionFormFieldsDataClient: IFieldSubmissionMap =
    submissionFormDataClient?.fieldSubmissionMap;
  for (const fieldId in submissionFormFieldsDataClient) {
    if (fieldsToHide.includes(fieldId)) continue;
    const fieldData = fieldsMap[fieldId];
    if (pageToHide.includes(fieldData?.parentFormId)) continue;
    if (configPageId.includes(fieldData?.parentFormId)) continue;
    const isDuplicateAllowed = fieldData?.isDuplicateAllowed;
    if (isDuplicateAllowed == undefined || isDuplicateAllowed) continue;
    const { fieldType, fieldSubmissionValue } =
      submissionFormFieldsDataClient[fieldId];
    let fieldValue;

    switch (fieldType) {
      case FormFieldTypes?.DROPDOWN:
        fieldValue = fieldSubmissionValue?.selectedOption;
        break;
      case FormFieldTypes?.MULTIPLE_CHOICES:
        if (fieldSubmissionValue?.selectedOption) {
          //selectedOption for single select
          fieldValue = fieldSubmissionValue?.selectedOption;
        }
        if (fieldSubmissionValue?.selectedOptions) {
          //selectedOptions for multi select
          fieldValue = fieldSubmissionValue?.selectedOptions;
        }
        break;
      case FormFieldTypes?.LINEAR_SCALING:
        fieldValue = fieldSubmissionValue?.selectedOption;
        break;
      case FormFieldTypes?.FILE_UPLOAD:
        fieldValue = fieldSubmissionValue?.uploadedFiles;
        break;
      case FormFieldTypes?.RATING:
        fieldValue = fieldSubmissionValue?.selectedOption;
        break;
      case FormFieldTypes?.CHECK_BOX:
        fieldValue = fieldSubmissionValue?.checkBoxValue;
        break;
      case FormFieldTypes?.SIGNATURE_BOX:
        fieldValue = fieldSubmissionValue?.manualSignatureData;
        break;
      case FormFieldTypes?.DOUBLE_PANEL:
        fieldValue = fieldSubmissionValue?.panelSelectedItemList;
        break;
      case FormFieldTypes?.LOOKUP:
        fieldValue =
          fieldSubmissionValue?.selectedOption ?? fieldSubmissionValue?.value;
        break;
      default:
        fieldValue = fieldSubmissionValue?.value;
        break;
    }

    if (fieldValue != "") {
      const fieldDetail: IDuplicateCheckFieldData = {
        localId: fieldId,
        value: fieldValue,
      };
      fieldDetails.push(fieldDetail);
    }
  }

  formCompositeKeyFields?.map(({ content, value }, index) => {
    const submissionData = submissionFormFieldsDataClient[value];
    if (!submissionData) return;
    const fieldSubmissionValue =
      submissionFormFieldsDataClient?.[value]?.fieldSubmissionValue;
    const fieldType = submissionFormFieldsDataClient?.[value]?.fieldType;
    const fieldData = fieldsMap[value];
    const isDuplicateAllowed = fieldData?.isDuplicateAllowed;
    if (isDuplicateAllowed) {
      let submissionValue: string | number | IMultiChoiceFieldOptionsClient[] =
        fieldSubmissionValue?.value;
      if (
        fieldType == FormFieldTypes.NUMBER_INPUT &&
        `${submissionValue}` == "" &&
        !submissionValue
      ) {
        submissionValue = 0;
      }
      if (
        (fieldType == FormFieldTypes.LOOKUP ||
          fieldType == FormFieldTypes.DROPDOWN) &&
        (submissionValue === undefined || submissionValue === "")
      ) {
        submissionValue = fieldSubmissionValue?.selectedOption;
      } else if (fieldType == FormFieldTypes.YEAR_SELECTOR) {
        submissionValue = fieldSubmissionValue?.selectedOptions;
      }

      const compositeKeyFieldDetail: IDuplicateCheckFieldData = {
        localId: value,
        value: submissionValue,
      };
      compositeFieldDetails.push(compositeKeyFieldDetail);
    }
  });

  let submissionFormDataServer: IDuplicateCheckFormData = {
    formId: formId,
    fieldDetails: fieldDetails,
    compositeFieldDetails: compositeFieldDetails,
  };
  if (submissionId) {
    submissionFormDataServer = {
      ...submissionFormDataServer,
      submissionId: submissionId,
    };
  }
  return submissionFormDataServer;
};

export const getUserIdFromSubmission = (
  data: ISubmissionFormFieldDataServer
) => {
  let userId = "";
  const userData = data["internal-user-id"];
  if (typeof userData === "object") {
    userId = userData["optionKey"];
  } else if (typeof userData === "string") {
    userId = userData;
  }
  return userId;
};
function getUpdatedFields(existingMap, fieldSubmissionMap) {
  const updatedFields = {};

  for (const key in fieldSubmissionMap) {
    const newField = fieldSubmissionMap[key];
    const oldField = existingMap[key];

    const newValue = newField?.fieldSubmissionValue?.value;
    const oldValue = oldField?.fieldSubmissionValue?.value;

    if (newValue !== oldValue) {
      updatedFields[key] = newField;
    }
  }

  return updatedFields;
}

export const transformDatagridValueServerToClient = (
  data: ITableSubmissionMap,
  formId: string,
  fieldsToHide: string[],
  pageToHide: string[],
  fieldsMap: IFieldsMap,
  datagridMapper?: any,
  formDatagridMapper?: any,
  submissionMap?: any,
  fieldId?: string,
  submissionId?: string
): ITableSubmissionMapServer => {
  const transformedTableSubmissionValue: any = [];
  const isReferenceDatagrid =
    fieldsMap[fieldId]?.fieldValue?.referenceFormId?.length &&
    fieldsMap[fieldId]?.fieldValue?.isReference;
  for (const item in data) {
    const fieldSubmissionMap = data[item];
    const tableSubmissionData: IFormSubmission = {
      localId: formId,
      fieldSubmissionMap: fieldSubmissionMap,
    };
    const submissionTableValue: ISubmissionFormDataServer =
      transFormSubmissionDataClientToServer(
        tableSubmissionData,
        formId,
        fieldsToHide,
        pageToHide,
        fieldsMap,
        0,
        formDatagridMapper
      );
    const rowSubmissionIdValue = {
      ...(typeof item === "string" &&
        !item?.startsWith("__") &&
        submissionId?.length &&
        isReferenceDatagrid && { id: item }),
    };
    if (Object.keys(submissionTableValue?.formData)?.length) {
      transformedTableSubmissionValue.push({
        ...rowSubmissionIdValue,
        ...submissionTableValue?.formData,
      });
    }
  }
  if (Object.keys(datagridMapper ?? {})?.length) {
    for (const item of Object.keys(datagridMapper)) {
      if (
        datagridMapper[item] === "DELETED" &&
        typeof item === "string" &&
        !item.startsWith("__") &&
        submissionId?.length &&
        isReferenceDatagrid
      ) {
        const rowSubmissionIdValue = {
          id: item,
          archived: true,
        };
        transformedTableSubmissionValue.push(rowSubmissionIdValue);
      }
    }
  }
  return transformedTableSubmissionValue;
};

export const transformDatagridValueClientToServer = (
  data: ITableSubmissionMapServer,
  formBuilderFormDataServer: IFormServer
): ITableSubmissionMap => {
  const transformedTableSubmissionValue: ITableSubmissionMap = {};
  for (const item in data) {
    const submissionDataServer: ISubmissionFormFieldDataServer = data[item];
    const rowKey = submissionDataServer?.id?.toString() ?? (Array.isArray(data) ? `__${item}` : item);
    const submissionTableDataServer: ISubmissionFormDataServer = {
      id: rowKey,
      formId: formBuilderFormDataServer?.localId,
      formData: submissionDataServer,
      relatedSubmissionIds: [],
    };
    const submissionTableValue: IFormSubmission =
      transFormSubmissionDataServerToClient(
        submissionTableDataServer,
        formBuilderFormDataServer,
        []
      );
    const submissionData = submissionTableValue?.fieldSubmissionMap;
    transformedTableSubmissionValue[rowKey] = submissionData;
  }

  return transformedTableSubmissionValue;
};

export const transformFieldSubmissionValueFromServerToClient = (
  fieldType: string,
  fieldSubmissionValueClient: any,
  formId?: string,
  fieldsToHide?: string[],
  pageToHide?: string[],
  fieldsMap?: any,
  subId?: string
) => {
  let fieldSubmissionValue: any; //ISubmissionFieldDataClient define type after merging FB-81
  switch (fieldType) {
    case FormFieldTypes.DROPDOWN:
      if (Array.isArray(fieldSubmissionValueClient)) {
        fieldSubmissionValue = {
          selectedOptions: fieldSubmissionValueClient || [],
        };
      } else if (typeof fieldSubmissionValueClient === "string") {
        fieldSubmissionValue = {
          selectedOption: {
            optionKey: fieldSubmissionValueClient,
            optionValue: fieldSubmissionValueClient,
          },
        };
      } else {
        fieldSubmissionValue = {
          selectedOption: fieldSubmissionValueClient,
        };
      }
      break;
    case FormFieldTypes.MULTIPLE_CHOICES:
      if (Array.isArray(fieldSubmissionValueClient)) {
        fieldSubmissionValue = {
          selectedOptions: fieldSubmissionValueClient || [],
        };
      } else {
        fieldSubmissionValue = {
          selectedOption: fieldSubmissionValueClient,
        };
      }
      break;
    case FormFieldTypes.LINEAR_SCALING:
      fieldSubmissionValue = {
        selectedOption: fieldSubmissionValueClient,
      };
      break;
    case FormFieldTypes.FILE_UPLOAD:
      fieldSubmissionValue = {
        uploadedFiles: fieldSubmissionValueClient,
      };
      break;
    case FormFieldTypes.RATING:
      fieldSubmissionValue = {
        selectedOption: fieldSubmissionValueClient,
      };
      break;
    case FormFieldTypes.CHECK_BOX:
      fieldSubmissionValue = {
        checkBoxValue: fieldSubmissionValueClient,
      };
      break;
    case FormFieldTypes.SIGNATURE_BOX:
      fieldSubmissionValue = {
        manualSignatureData: fieldSubmissionValueClient || "",
      };
      break;
    case FormFieldTypes.DOUBLE_PANEL:
      fieldSubmissionValue = {
        panelSelectedItemList: fieldSubmissionValueClient || [],
      };
      break;
    case FormFieldTypes.DATE_INPUT:
      fieldSubmissionValue = {
        value: fieldSubmissionValueClient || "",
      };
      break;
    case FormFieldTypes.DATE_TIME_PICKER:
      fieldSubmissionValue = {
        value: fieldSubmissionValueClient || "",
      };
      break;
    case FormFieldTypes.PAYMENT:
      fieldSubmissionValue = {
        paymentValue: {
          amount: fieldSubmissionValueClient?.txnAmount + "" || "",
          orderId: fieldSubmissionValueClient?.orderId + "" || "",
          updatedDate: fieldSubmissionValueClient?.updatedDate + "" || "",
          status: fieldSubmissionValueClient?.status + "" || "",
          paymentGateway: fieldSubmissionValueClient?.paymentGateway + "" || "",
        },
      };
      break;
    case FormFieldTypes.GEOLOCATION:
      fieldSubmissionValue = {
        geolocationValue: {
          latitude: fieldSubmissionValueClient?.latitude + "" || "",
          longitude: fieldSubmissionValueClient?.longitude + "" || "",
          address: fieldSubmissionValueClient?.address || "",
        },
      };
      break;
    case FormFieldTypes.DATA_GRID:
      fieldSubmissionValue = {
        dataGridValue: fieldSubmissionValueClient,
      };
      break;
    case FormFieldTypes.LOOKUP:
      fieldSubmissionValue = {
        selectedOption: {
          optionKey: subId,
          optionValue: fieldSubmissionValueClient,
        },
      };
      break;
    case FormFieldTypes.TEXT_INPUT:
      let textData = fieldSubmissionValueClient;
      if (Array.isArray(fieldSubmissionValueClient)) {
        textData = extractValues(fieldSubmissionValueClient);
      } else if (typeof fieldSubmissionValueClient == "object") {
        textData = fieldSubmissionValueClient?.optionValue || "";
      }
      fieldSubmissionValue = {
        value: `${textData}`,
      };
      break;
    default:
      let val = fieldSubmissionValueClient;
      if (Array.isArray(fieldSubmissionValueClient)) {
        val = extractValues(fieldSubmissionValueClient);
      } else if (typeof fieldSubmissionValueClient == "object") {
        val = fieldSubmissionValueClient?.optionValue || "";
      }
      fieldSubmissionValue = {
        value: val,
      };
      break;
  }
  return fieldSubmissionValue;
};

const extractValues = (arr) => {
  const values = arr.map((item) => item.optionValue);
  const val = values.join(", ");
  return val;
};

export const transformFieldSubmissionValuesClientToServer = (
  fieldType: string,
  fieldSubmissionValue: any
) => {
  if (fieldType == "") return;
  let submissionFormFieldsDataServer;
  switch (fieldType) {
    case FormFieldTypes?.DROPDOWN:
      if (fieldSubmissionValue?.selectedOption) {
        //selectedOption for single select
        submissionFormFieldsDataServer = fieldSubmissionValue?.selectedOption;
      }
      if (fieldSubmissionValue?.selectedOptions) {
        //selectedOptions for multi select
        submissionFormFieldsDataServer = fieldSubmissionValue?.selectedOptions;
      }
      break;
    case FormFieldTypes?.MULTIPLE_CHOICES:
    case FormFieldTypes?.YEAR_SELECTOR:
      if (fieldSubmissionValue?.selectedOption) {
        //selectedOption for single select
        submissionFormFieldsDataServer = fieldSubmissionValue?.selectedOption;
      }
      if (fieldSubmissionValue?.selectedOptions) {
        //selectedOptions for multi select
        submissionFormFieldsDataServer = fieldSubmissionValue?.selectedOptions;
      }
      break;
    case FormFieldTypes?.LINEAR_SCALING:
      submissionFormFieldsDataServer = fieldSubmissionValue?.selectedOption;
      break;
    case FormFieldTypes?.FILE_UPLOAD:
      submissionFormFieldsDataServer = fieldSubmissionValue?.uploadedFiles;
      break;
    case FormFieldTypes?.RATING:
      submissionFormFieldsDataServer = fieldSubmissionValue?.selectedOption;
      break;
    case FormFieldTypes?.CHECK_BOX:
      submissionFormFieldsDataServer = fieldSubmissionValue?.checkBoxValue;
      break;
    case FormFieldTypes?.SIGNATURE_BOX:
      submissionFormFieldsDataServer =
        fieldSubmissionValue?.manualSignatureData;
      break;
    case FormFieldTypes?.DOUBLE_PANEL:
      submissionFormFieldsDataServer =
        fieldSubmissionValue?.panelSelectedItemList;
      break;
    case FormFieldTypes?.PAYMENT:
      submissionFormFieldsDataServer =
        fieldSubmissionValue?.paymentValue?.amount;
      break;

    case FormFieldTypes?.GEOLOCATION:
      submissionFormFieldsDataServer = fieldSubmissionValue?.geolocationValue; // update based on use
      break;

    case FormFieldTypes?.LOOKUP:
      if (fieldSubmissionValue?.selectedOption) {
        //selectedOption for single select
        submissionFormFieldsDataServer = fieldSubmissionValue?.selectedOption;
      }
      if (fieldSubmissionValue?.selectedOptions) {
        //selectedOptions for multi select
        submissionFormFieldsDataServer = fieldSubmissionValue?.selectedOptions;
      }
      break;

    default:
      submissionFormFieldsDataServer = fieldSubmissionValue?.value;
      break;
  }
  return submissionFormFieldsDataServer;
};

export const formActionInitialValue: IFormLevelRuleActionServer[] = [
  {
    actionType: "SEND_MAIL",
    value: "",
    emailActionConfig: {
      templateType: "",
      templateId: "",
      from: "",
      to: {
        type: "ALL",
        value: "",
      },
      subject: "",
      body: "",
    },
  },
  {
    actionType: "SEND_SMS",
    value: "",
    smsActionConfig: {
      to: "",
      body: "",
    },
  },
  {
    actionType: "SEND_WHATSAPP",
    value: "",
    whatsAppActionConfig: {
      to: "",
      body: "",
    },
  },
  {
    actionType: "SEND_NOTIFICATION",
    value: "",
    notificationActionConfig: {
      to: {
        type: "ALL",
        value: "",
      },
      body: "",
    },
  },
  {
    actionType: "REDIRECT",
    value: "",
    redirectActionConfig: {
      type: "WEBSITE",
      link: "",
      openIn: "",
    },
  },
  {
    actionType: "MAP_DATA",
    value: "",
    mapDataActionConfig: {
      selectedFormId: "",
      fromFieldId: "",
      toFieldId: "",
      type: "ADD",
    },
  },
];

export const transformRulesActionToWorkflowAction = (
  rulesActions: IFormLevelRuleActionServer[]
): IWorkflowNotification => {
  let workflowNotification: IWorkflowNotification = {
    sendEmail: {
      templateType: "",
      templateId: "",
      from: "",
      to: {
        type: "ALL",
        value: "",
      },
      subject: "",
      body: "",
    },
    sendSms: {
      to: "",
      message: "",
    },
    sendWhatsApp: {
      to: "",
      message: "",
    },
    notification: {
      to: {
        type: "",
        value: "",
      },
      message: "",
    },
    redirectToUrl: {
      link: "",
      openIn: "",
      urlType: "",
    },
  };
  // const mapDataAction = mapDataActionConfig;

  const rulesActionsData = rulesActions || formActionInitialValue;

  for (let i = 0; i < rulesActionsData.length; i++) {
    const rulesAction = rulesActionsData[i];
    const emailActionConfig = rulesAction?.emailActionConfig;
    const smsActionConfig = rulesAction?.smsActionConfig;
    const whatsAppActionConfig = rulesAction?.whatsAppActionConfig;
    // const mapDataActionConfig = rulesAction?.mapDataActionConfig;
    const notificationActionConfig = rulesAction?.notificationActionConfig;
    const redirectActionConfig = rulesAction?.redirectActionConfig;
    if (emailActionConfig) {
      workflowNotification = {
        ...workflowNotification,
        sendEmail: emailActionConfig,
      };
    } else if (smsActionConfig) {
      workflowNotification = {
        ...workflowNotification,
        sendSms: {
          to: smsActionConfig?.to || "",
          message: smsActionConfig?.body || "",
        },
      };
    } else if (whatsAppActionConfig) {
      workflowNotification = {
        ...workflowNotification,
        sendWhatsApp: {
          to: whatsAppActionConfig?.to || "",
          message: whatsAppActionConfig?.body || "",
        },
      };
    } else if (notificationActionConfig) {
      workflowNotification = {
        ...workflowNotification,
        notification: {
          to: notificationActionConfig?.to,
          message: notificationActionConfig?.body || "",
        },
      };
    } else if (redirectActionConfig) {
      workflowNotification = {
        ...workflowNotification,
        redirectToUrl: {
          link: redirectActionConfig?.link || "",
          openIn: redirectActionConfig?.openIn || "",
          urlType: redirectActionConfig?.type || "",
        },
      };
    }
    // else if (mapDataActionConfig) {
    //   const mapDataAction = mapDataActionConfig;
    // }
  }
  return workflowNotification;
};

export const validateFormRuleForWorkflow = (
  workflowList: IWorkflowServer[],
  hiddenField: string[],
  fieldSubmissionMap: IFieldSubmissionMap,
  currentEvent: Events
): string[] => {
  const supportedWorkflowsIds: string[] = [];
  workflowList.forEach((workflowServer: IWorkflowServer) => {
    const formRules = workflowServer?.workflow?.rules?.formRules || [];
    formRules.forEach((formRule: IFormLevelRuleClient) => {
      const { logicalOperator, conditions } = formRule;
      const isValidated = checkFieldRuleConditions(
        conditions,
        logicalOperator,
        hiddenField,
        fieldSubmissionMap
      );
      if (
        (isValidated && workflowServer.workflow.event == currentEvent) ||
        (workflowServer.workflow.event == Events.CREATEDEDITED &&
          workflowServer.isEnabled &&
          !supportedWorkflowsIds.includes(workflowServer?.id))
      ) {
        supportedWorkflowsIds.push(workflowServer?.id);
      }
    });
  });

  return supportedWorkflowsIds;
};
export const extractDatagridFields = (
  fieldsMap: IFieldsMap
): IDatagridValue => {
  const datagridFields: string[] = [];
  const datagridMapping: Record<string, string[]> = {};

  for (const fieldId in fieldsMap) {
    const field = fieldsMap[fieldId];

    if (field.fieldType === "DATA_GRID") {
      datagridMapping[fieldId] = field.fields || [];
      const dataGridFields = field.fields ?? [];
      for (const datagridFieldId of dataGridFields) {
        datagridFields.push(datagridFieldId);
      }
    }
  }

  return { datagridFields, datagridMapping };
};

const stringToExecutableFunction = (stringFunction: string) => {
  const myFunction = new Function(`return (${stringFunction})`);
  return myFunction();
};


export const handleCallJavascript = (
  code: string,
  payload: any,
) => {
  if (code === "") return;
  const executableTransformer = stringToExecutableFunction(code);
  executableTransformer?.(code, payload);
};
